// This function selects the suggested size
function confirmSize(event) {
  const variant = product.variants.find((v) => v.id == event.detail.code);
  if (!variant) return;
  variant.options.forEach((optionValue, index) => {
    const optionName = product.options[index];
    const escapedOptionValue = CSS.escape(optionValue);
    const selector = `[name^="${optionName}"][value="${escapedOptionValue}"]`;
    const element = document.querySelector(selector);
    element?.click();
  });
};

// This function updates the widget code
const handleVariantChange = (event) => {
  const widget = document.querySelector('#onlinesizing-widget');
  widget?.setAttribute('variant-id', event.data.variant.id);
};

if (window.FoxTheme?.pubsub?.subscribe) {
  window.FoxTheme.pubsub.subscribe(
    window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
    handleVariantChange
  );
} else {
  document.addEventListener('variant:change', (event) => {
    if (!event?.detail?.variant) return;
    handleVariantChange({ data: { variant: event.detail.variant } });
  });
}